var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnIcCheckDoubleFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73463 9.17342L8.67596 10.1148L14.32 4.47075L15.2627 5.41342L8.67596 12.0001L4.43329 7.75742L5.37596 6.81475L6.79263 8.23142L7.73463 9.17275V9.17342ZM7.73596 7.28808L11.0373 3.98608L11.9773 4.92608L8.67596 8.22808L7.73596 7.28808ZM5.85129 11.0581L4.90929 12.0001L0.666626 7.75742L1.60929 6.81475L2.55129 7.75675L2.55063 7.75742L5.85129 11.0581Z",
    fill: "#2FAC4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnIcCheckDoubleFill);
export default __webpack_public_path__ + "static/media/icn_ic_check-double-fill.3fc036c8f81a1a6188f48933bcd66411.svg";
export { ForwardRef as ReactComponent };